<template>
  <div class="quizset-button-create" @click="create">
    クイズセットの作成
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [
    MixinResultHandler
  ],

  methods: {
    create: async function () {
      const result = await this.$store.dispatch(
        'quizset/saveQuizset',
        'new'
      )
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.quizset-button-create {
  @include button-ol-success;
}
</style>
